import i18n from '../../i18n'

const BRAND_SUFFIX = 'Groute'

export type PageTitleKey =
  | 'dashboard'
  | 'vehicles'
  | 'addVehicle'
  | 'editVehicle'
  | 'drivers'
  | 'addDriver'
  | 'editDriver'
  | 'routes'
  | 'createRoute'
  | 'calculateRoute'
  | 'fleetMap'
  | 'devices'
  | 'documents'
  | 'messages'
  | 'notifications'
  | 'tasks'
  | 'reports'
  | 'ecoDriving'
  | 'compliance'
  | 'fuelAnomaly'
  | 'tachographActivities'
  | 'vehicleActivity'
  | 'driverActivity'
  | 'dddViewer'
  | 'login'
  | 'forgotPassword'
  | 'resetPassword'
  | 'vehicleLocation'

export const pageTitle = (page: string) => `${page} · ${BRAND_SUFFIX}`

export const localizedPageTitle = (key: PageTitleKey) =>
  pageTitle(i18n.t(`common:pageTitles.${key}`))
